/**
 * @generated SignedSource<<370e9adea12cd328170f5a0a7e2f6e29>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type autoCorrection_AtlassianSearchPage$data = {
  readonly confidenceScore: number | null | undefined;
  readonly originalQuery: string | null | undefined;
  readonly originalQueryType: string | null | undefined;
  readonly replacementQuery: string | null | undefined;
  readonly shouldTriggerAutocorrectionExperience: boolean | null | undefined;
  readonly suggestedQuery: string | null | undefined;
  readonly " $fragmentType": "autoCorrection_AtlassianSearchPage";
};
export type autoCorrection_AtlassianSearchPage$key = {
  readonly " $data"?: autoCorrection_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"autoCorrection_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "autoCorrection_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "originalQuery"
    },
    {
      "kind": "ScalarField",
      "name": "replacementQuery"
    },
    {
      "kind": "ScalarField",
      "name": "suggestedQuery"
    },
    {
      "kind": "ScalarField",
      "name": "originalQueryType"
    },
    {
      "kind": "ScalarField",
      "name": "confidenceScore"
    },
    {
      "kind": "ScalarField",
      "name": "shouldTriggerAutocorrectionExperience"
    }
  ],
  "type": "SearchQueryInfo"
};

(node as any).hash = "c10236f368a121324971f6864af67d34";

export default node;
